import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from "../../AbstractElements";
import EquipmentHome from "./EquipmentHome";

export default function EquipmentList() {
    return (
        <Fragment>
            <Breadcrumbs
                mainTitle="List of Equipment"
                parent="Home"
                title="List of Equipment"
            />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <EquipmentHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
